// src/config/colors.js
export const colors = {
    primary: '#255946',
    secondary: '#49A760',
    tertiary: '#1F4E3D',
    accent: '#EFB443',

    // ... otros colores ...
    lightPrimary: '#60ad5e', // Un tono más claro del color primario
    darkPrimary: '#003622', // Un tono más oscuro del color primario
    lightAccent: '#f4c072', // Un tono más claro del color de acento
    darkAccent: '#b07b29', // Un tono más oscuro del color de acento
};
